import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProductService } from '@eo-storefronts/eo-core'

export const loadProducts = createAsyncThunk(
  'products/loadProductsStatus',
  async () => {
    return ProductService.getProductData()
  }
)
